import React from 'react';

import { getIconCss, mediumSize, smallSize } from './icon.style';

import smallIconSet from './icon-set/small/icon-set';
import mediumIconSet from './icon-set/medium/icon-set';

export type IconSize = 'small' | 'medium';

export const IconNames = [
    'add',
    'age',
    'android-more',
    'arrange',
    'arrow-diagonal-left',
    'arrow-diagonal-right',
    'arrow-down-big',
    'arrow-left-big',
    'arrow-right-big',
    'arrow-rotate-clockwise',
    'arrow-rotate-anticlockwise',
    'arrow-rotate',
    'arrow-up-big',
    'arrow-up-down',
    'attachment',
    'back-arrow',
    'basket',
    'bell-checkmark',
    'bell-notification-add',
    'bell',
    'bookmark',
    'bullet-list-text',
    'calendar',
    'camera-add',
    'camera',
    'car',
    'cat',
    'categories',
    'chart-board',
    'chart',
    'check-list',
    'checkbox-checkmark',
    'checkbox-delete',
    'checkbox-minus',
    'checkbox',
    'checkmark',
    'chevron-back',
    'chevron-down',
    'chevron-forward',
    'chevron-up',
    'circle-checkmark',
    'circle-delete',
    'circle-minus',
    'clock-time-arrow',
    'clock',
    'close',
    'community',
    'crop',
    'delete',
    'diy',
    'document-file-add',
    'document-file-blank',
    'dog',
    'download',
    'driving-convenience',
    'dropdown-up',
    'dropdown',
    'engine',
    'eye-hidden',
    'eye-view',
    'facebook',
    'filter',
    'forward-arrow',
    'fuel',
    'full-screen',
    'google',
    'gumtree-home',
    'heart',
    'home',
    'hypelink-out',
    'image',
    'info',
    'instagram',
    'interior',
    'ios-more',
    'jobs',
    'kids',
    'letter',
    'light-bulb',
    'loader',
    'location-android',
    'location-ios',
    'location',
    'lock',
    'map',
    'menu-dots-circle-horiz',
    'menu-dots-circle-vert',
    'menu',
    'message-bubble',
    'message-left',
    'message-recieved',
    'message-right',
    'messages',
    'meta-messenger',
    'microphone',
    'miles',
    'minus',
    'overview',
    'pen-edit',
    'pen',
    'performance',
    'pets',
    'phone',
    'pinterest',
    'plus',
    'private',
    'properties',
    'question-circle',
    'report',
    'running-costs',
    'safety-security',
    'sale',
    'search',
    'send',
    'services',
    'setting',
    'sex',
    'share-android',
    'share-ios',
    'share',
    'sort',
    'spinner',
    'sports',
    'star-check-mark',
    'star-filled',
    'star-half-filled',
    'star',
    'stickers',
    'trade',
    'transmission',
    'twitter',
    'user',
    'video',
    'warning-triangle',
    'warning',
    'whatsup',
    'youtube',
    'zoom-in',
    'zoom-out',
] as const;

export type IconName = typeof IconNames[number];

export interface IconProps {
    type: IconName;
    color?: string;
    size?: IconSize;
}

const iconMappings = {
    small: smallIconSet,
    medium: mediumIconSet,
};

const Icon = ({ type, color, size = 'medium' }: IconProps) => {
    const IconToRender = iconMappings[size][type];

    let sizeCss = mediumSize;

    if (size === 'small') {
        sizeCss = smallSize;
    }

    return (
        <span data-testid={`icon-${type}`} css={[getIconCss(color), sizeCss]}>
            <IconToRender />
        </span>
    );
};

export default Icon;
